import React from "react";
import { List, Descriptions } from "antd";

export default function ContractRentableAreas({
  rentableareas = [],
  ...props
}) {
  return (
    <List
      {...props}
      dataSource={rentableareas}
      style={{ backgroundColor: "#fff" }}
      bordered
      renderItem={(item, index) => {
        const rentablearea = item.rentableArea;
        return (
          <List.Item className="customized" key={rentablearea.id}>
            <Descriptions column={{ xs: 1, sm: 2, md: 3 }}>
              <Descriptions.Item label="Kod">
                {rentablearea.code}
              </Descriptions.Item>
              <Descriptions.Item label="Birim">
                {rentablearea.subUnit?.unit?.description}
              </Descriptions.Item>
              <Descriptions.Item label="Alt Birim">
                {rentablearea.subUnit?.description}
              </Descriptions.Item>
              <Descriptions.Item label="Adres">
                {rentablearea.address}
              </Descriptions.Item>
              <Descriptions.Item label="Tür">
                {rentablearea.rentableAreaType?.description}
              </Descriptions.Item>
              <Descriptions.Item label="Açıklama">
                {rentablearea.description}
              </Descriptions.Item>
            </Descriptions>
          </List.Item>
        );
      }}
    />
  );
}
